import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUserCircle, FaPhoneSquare, FaEnvelope } from "react-icons/fa";
import constants from "../../../constants";
import LoadMoreList from "../../../services/LoadMoreList";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl, setServiceUserIdSession } from "../../../services/GlobalUrls";
const ServiceUserDetailsCandidateMobile = (props) => {
  const [serviceUserDetails, setServiceUserDetails] = useState([]);
  const [filter, setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    setServiceUserDetails(props.serviceUserDetailsCandidate);
  }, [props.serviceUserDetailsCandidate]);
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (serviceUserDetailsCandidates) => {
    const searchText = inputValue.toLowerCase();
    return (
      serviceUserDetailsCandidates.domiciliary_care_client_service_user_created_date
        ?.toLowerCase()
        .includes(searchText) ||
      serviceUserDetailsCandidates.service_user_name
        ?.toLowerCase()
        .includes(searchText) ||
      serviceUserDetailsCandidates.domiciliary_care_client_service_user_mobile_number
        ?.toLowerCase()
        .includes(searchText) ||
      serviceUserDetailsCandidates.domiciliary_care_client_service_user_email
        ?.toLowerCase()
        .includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = serviceUserDetails
    ? serviceUserDetails.filter(matchesSearchText)
    : [];
  //   Filter - End

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
             
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(service_user_details_candidate, i) => (
                <ul
                  className="nav navbar-nav border border-grey p-4 mb-2"
                  style={{ borderRadius: "20px" }}
                  key={i}
                >
                  <li className="text-dark">
                    <FaCalendarAlt className="mr-1 text-primary" />{" "}
                    {
                      service_user_details_candidate.domiciliary_care_client_service_user_created_date
                    }
                  </li>
                  <li className="text-primary" onClick={() => setServiceUserIdSession(service_user_details_candidate.domiciliary_care_client_id)}>
                    <FaUserCircle className="mr-1 text-primary" />{" "}
                    {service_user_details_candidate.service_user_name}
                  </li>
                  <li className="text-dark">
                    <FaPhoneSquare className="mr-1 text-primary" />{" "}
                    {service_user_details_candidate.domiciliary_care_client_service_user_mobile_number}
                  </li>
                  <li className="text-dark">
                    <FaEnvelope className="mr-1 text-primary" />{" "}
                    {
                      service_user_details_candidate.domiciliary_care_client_service_user_email
                    }
                  </li>
                </ul>
            )}
          />
        </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Uploaded Documents"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    serviceUserDetailsCandidate:
      state.serviceUserDetailsCandidate.serviceUserDetailsCandidate,
  };
};

export default connect(mapStateToProps)(ServiceUserDetailsCandidateMobile);
